// A person-facing line for a failed room connection.
//
// Its own module, and a pure one: connectRoom constructs the E2EE worker at
// load, so anything living there cannot be imported by a test — and an error
// message nobody can test is how "could not establish pc connection" reached
// the meeting page verbatim in the first place.

/**
 * LiveKit's transport errors are engineering prose; people get one line that
 * says what to do. E2EE-unsupported messages pass through untouched — the
 * pages route those to a dedicated screen by matching on the wording. Unknown
 * errors stay verbatim rather than being hidden behind a generic line.
 */
export function humanConnectError(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err);
  if (raw.includes('end-to-end encryption')) return raw;
  const transient =
    raw.includes('could not establish') || // LiveKit signal/pc connection
    raw.includes('WebSocket') ||
    raw.includes('timeout') ||
    raw.includes('Failed to fetch');
  if (transient) {
    return 'Could not connect to the meeting. Check your connection and try again.';
  }
  return raw;
}
